exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".infoMessage-c9f7cb93{font-family:\"aktiv-grotesk\",\"Aktiv Grotesk\",\"Open Sans\",\"Gill Sans MT\",\"Gill Sans\",Corbel,Arial,sans-serif;max-width:600px;margin:0 auto;text-align:center;color:#666;font-size:14px}.infoMessage-c9f7cb93 p{line-height:1.5}.multibike-ec402238{margin-top:60px}.multibike-ec402238 i{display:inline-block;margin:0 10px}\n", ""]);

// Exports
exports.locals = {
	"infoMessage": "infoMessage-c9f7cb93",
	"multibike": "multibike-ec402238"
};